import dayjs from "@/helpers/dayjs"

import type { TagValue } from "@/pages/types/forms"
import type { CustomField } from "@/types/djangio"

export const formatTagDictQuery = (tagDict: Record<string, string | number | string[]>) => {
    return Object.entries(tagDict).reduce(
        (acc, [key, value]) => {
            if (key.includes("date_cf") && value) {
                acc[key] = new Date(`${value}T00:00:00`)
            } else {
                acc[key] = value
            }
            return acc
        },
        {} as Record<string, TagValue>,
    )
}

export const formatTagDictMutation = (tagDict: Record<string, TagValue>, customFields: CustomField[]) => {
    const numberCF = customFields
        ? customFields
              .filter((field) => field.tag_type === DjangIO.app.person.types.TagType.number.value)
              .map((field) => field.slug)
        : []
    if (tagDict) {
        return Object.entries(tagDict).reduce(
            (acc, [key, value]) => {
                if (key.includes("date_cf") && value) {
                    acc[key] = dayjs(value as Date).format("YYYY-MM-DD")
                } else if (numberCF.includes(key) && value) {
                    acc[key] = parseInt(value as string)
                } else {
                    acc[key] = value as Exclude<TagValue, Date>
                }
                return acc
            },
            {} as Record<string, Exclude<TagValue, Date>>,
        )
    }
    return {}
}
